import { ref } from 'vue';
import { downloads } from '@integro/core';
import { useErrorModal } from '../components/modal/useModal';

export function useAuthDownload() {
  const downloading = ref(false);
  const showError = useErrorModal();

  async function fetchFile(url: string, fileName?: string | null) {
    downloading.value = true;
    try {
      return await downloads.getFileBLOB(url, fileName ?? undefined);
    } catch (error) {
      showError(error);
    } finally {
      downloading.value = false;
    }
  }

  async function openFile(url: string, fileName?: string | null) {
    const result = await fetchFile(url, fileName);
    if (result) {
      downloads.showFileInNewTab(result.file, result.fileName);
    }
    return result;
  }

  async function saveFile(url: string, fileName?: string | null) {
    const result = await fetchFile(url, fileName);
    if (result) {
      downloads.downloadFile(result.file, fileName || result.fileName);
    }
    return result;
  }

  return { downloading, openFile, saveFile };
}
